<template>
  <div
    class="main demo-split"
    id="aa"
    :class="{ mapscreen: $store.state.isMapScreen }"
  >
    <Split v-model="split" min="0" max="400">
      <div slot="left" ref="left" style="height: 100%">
        <monitor-tree
          ref="fleetTree"
          modal="locate"
          deviceUseType="2"
          @selectCarList="reCarList"
          filterGroup="人员"
        ></monitor-tree>
      </div>
      <div slot="right" ref="right" style="height: 100%">
        <div id="left_right" @click="showHide">
          <Icon v-if="split == 0" type="md-arrow-dropright" />
          <Icon v-else type="md-arrow-dropleft" />
        </div>

        <g-map
          ref="postDevice"
          @dataWindow="dataWindow = $event"
          @areaCar="$refs.quyuchache.areaCarFunction($event)"
          ><icon-window
            ref="infoWindow"
            :windowData="dataWindow"
            slot="window"
            :minHeight="140"
          >
          </icon-window
        ></g-map>
      </div>
    </Split>
  </div>
</template>
<script>
import monitorTree from "./locateToolCarPerson.vue";
import gMap from "../map20/locate.vue";
import iconWindow from "./iconWindow";
export default {
  props: ["isToCenter"],
  data() {
    return {
      split: "300",
      leftLoteData: [],
      dataWindow: {},
    };
  },
  computed: {
    litenIsMapScreen() {
      return this.$store.state.isMapScreen;
    },
  },
  components: {
    monitorTree,
    gMap,
    iconWindow,
  },
  methods: {
    showHide() {
      if (this.split == 0) {
        this.split = "260";
        this.$refs.left.style.display = "block";
      } else {
        this.split = 0;
        this.$refs.left.style.display = "none";
      }
    },
    setHight() {},
    reCarList(v, isToCenter) {
      this.$refs.postDevice.websockToLocate(v, isToCenter);
    },
  },
  mounted() {
    //this.setHight();
    if (localStorage.getItem("Split1") == null) {
      // this.split = 0.1;
    } else {
      // this.split = Number(localStorage.getItem("Split1"));
    }
  },
  watch: {
    litenIsMapScreen(v) {
      if (v) {
        var height = window.screen.height;
        this.$refs.right.style.height = height - 5 + "px";
      } else {
        setTimeout(() => {
          var height = document.body.clientHeight;
          this.$refs.right.style.height = height - 55 + "px";
        }, 200);
      }
    },
  },
  /* deactivated() {
    console.log("离开页面了");
  }, */
};
</script>
<style>
/*去除百度地图版权*/
.anchorBL {
  display: none;
}

.demo-split {
  position: relative;
  border: 1px solid #dcdee2;
}
#left_right {
  position: absolute;
  left: 0;
  top: 48%;
  background: #333;
  width: 18px;
  line-height: 60px;
  z-index: 18;
  color: #fff;
  font-size: 18px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  opacity: 0.3;
}
#left_right:hover {
  opacity: 0.5;
}
.mapscreen {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6666;
  width: 100%;
  height: 100% !important;
  background: #f5f5f5;
  padding-top: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/personLocate.vue